// @core/api/endpoints/authn/exchange_token.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExchangeTokenRequest,
  TokenResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Exchange authorization code for tokens
 * Exchanges an authorization code, refresh token, or client credentials for access tokens. Supports multiple grant types and returns ID tokens for OIDC flows.
 * @public This endpoint does not require authentication
 */
export async function ExchangeToken(
  data: ExchangeTokenRequest,
  options?: RequestOptions
): Promise<TokenResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/token`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TokenResponse>(requestPath, data, requestOptions);
}
